// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"style_closeButton__WP4Mq","dark":"style_dark__C5kMN","large":"style_large__duCOR"};